import {initSelectableCard} from './SelectableCard';

const initializedContainers = new WeakSet();

export const initializeSelectableCards = root => {
    root.querySelectorAll('[data-controller="selectable-card"]').forEach(container => {
        if (initializedContainers.has(container)) {
            return;
        }

        initializedContainers.add(container);

        initSelectableCard(container);
    });
};
